// this value will be used:
// - main subState to inject to rootState (name to inject dynamic reducer)
// - inject sub saga
// MODULE_STATE_NAME
export const MODULE_STATE_NAME = 'ctrAdminCompanyDetails'

